import { GENERATE_OTP_FLOW } from '@models/auth.model'
import { getSpCpHeader, protocol } from './index'

const URL_GENERATE_OTP = '/api/GenerateOtp'
export const getGenerateOtp = (payload: any) => {
  let config = {}
  const { flow } = payload
  if (flow === GENERATE_OTP_FLOW.ONBOARDING) {
    config = getSpCpHeader()
  }
  return protocol.post(`${URL_GENERATE_OTP}`, payload, config)
}

const URL_POST_MANUAL_GENERATE_OTP = '/api/Otp/ManualAccountGenerateOTP'
export const getManualGenerateOTP = (payload: any) => {
  return protocol.get(URL_POST_MANUAL_GENERATE_OTP, { params: payload })
}

const URL_POST_MANUAL_VERIFY_OTP = '/api/Otp/ManualAccountVefiryOTP'
export const getManualVerifyOTP = (payload: any) => {
  return protocol.get(URL_POST_MANUAL_VERIFY_OTP, { params: payload })
}

const URL_LOGIN = '/api/login'
export const postLogin = (payload: any) => {
  return protocol.post(URL_LOGIN, payload)
}

const URL_LOGOUT = '/api/logout'
export const getLogout = () => {
  return protocol.get(URL_LOGOUT)
}

const URL_CALLBACK_SINGPASS = '/api/sp/callback'
export const postCallbackSingpass = (payload: {
  state: string
  code: string
}) => {
  return protocol.post(URL_CALLBACK_SINGPASS, payload)
}

const URL_CALLBACK_CORPPASS = '/api/cp/callback'
export const postCallbackCorppass = (payload: {
  state: string
  code: string
}) => {
  return protocol.post(URL_CALLBACK_CORPPASS, payload)
}

const URL_UPDATE_CONTACT_NUMBER = '/user/ContactNo'
export const putUpdateContactNumber = (payload: any) => {
  return protocol.put(`${URL_UPDATE_CONTACT_NUMBER}`, payload)
}

const URL_GET_MY_INFO = '/api/sp/getmi'
export const postGetMyInfo = (payload: any) => {
  return protocol.post(`${URL_GET_MY_INFO}`, payload)
}

const URL_SET_FIRST_TIME = '/api/setFirstTimeLogin'
export const setFirstTimeLogin = () => {
  return protocol.post(URL_SET_FIRST_TIME, {})
}

const URL_REFRESH_TOKEN = '/user/refresh-token'
export const postRefreshToken = () => {
  return protocol.post(URL_REFRESH_TOKEN, {})
}

const URL_CORPPASS_LOGIN = '/api/sp/cpLogin'
export const getCorppassLogin = () => {
  return protocol.get(URL_CORPPASS_LOGIN)
}

const URL_SINGPASS_LOGIN = '/api/sp/spLogin'
export const getSingpassLogin = () => {
  return protocol.get(URL_SINGPASS_LOGIN)
}
